export var Name = 'virtual-page';
export var VirtualPage = Name;